export const PLUGINS = {
  IMAGE: 'image',
  VIDEO: 'video',
  LINK: 'link',
  HASHTAG: 'hashtag',
  DIVIDER: 'divider',
  HTML: 'html',
  MENTIONS: 'mentions',
  CODE_BLOCK: 'code_block',
};
